export const TIPO_VALOR_LABELS: Record<string, string> = {
  salario_base: 'Salário base',
  horas_extras: 'Horas extras',
  comissoes: 'Comissões',
  adicionais: 'Adicionais',
  vale_alimentacao: 'Vale alimentação',
  vale_transporte: 'Vale transporte',
  reembolsos: 'Reembolsos',
  ferias: 'Férias',
  decimo_terceiro: '13º salário'
};

export function formatCNPJ(value: string) {
  const d = String(value).replace(/\D/g, '');
  if (d.length !== 14) return value;
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}

export function formatBRL(value: number | null | undefined) {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return Number(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function formatScoreLabel(value: number | null | undefined) {
  if (value == null || Number.isNaN(Number(value))) return '—';
  const n = Number(value);
  if (n >= 0 && n <= 1) {
    return `${(n * 100).toFixed(1)}%`;
  }
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function labelTipoValor(tipo: string) {
  const key = tipo?.toLowerCase?.() ?? tipo;
  return TIPO_VALOR_LABELS[key] ?? tipo.replace(/_/g, ' ');
}
